import { render, staticRenderFns } from "./PorezDetails.vue?vue&type=template&id=6f3518a7&scoped=true&"
import script from "./PorezDetails.vue?vue&type=script&lang=js&"
export * from "./PorezDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3518a7",
  null
  
)

export default component.exports